function redirectToLogin(email) {
    window.location.href = `/Login?email=${encodeURIComponent(email)}&autolog=true`;
}

function  SearchBarClicked() {
}

function searchBarLoaded() {

}

function SearchBarChanged() {
    var searchValue = document.getElementById('searchfield').value.toLowerCase();
    var userItems = document.querySelectorAll('#userList li:has(.user-button)');
    let hasResults = false;

    userItems.forEach(function (item) {
        var userName = item.querySelector('.username').textContent.toLowerCase();
        if (userName.includes(searchValue)) {
            item.hidden = false;
            hasResults = true;
        } else {
            item.hidden = true;
        }
    });

    document.getElementById("noResults").hidden = hasResults;
}



